import { mapTypescriptRecord } from '@shared/utils/record.mapper.utils'
import {
  castDateTimeFormat,
  castNumberFormat,
} from 'src/tpbp-core/utils/formatter/config.utils'
import {
  DATE_FORMATS,
  NUMBER_FORMATS,
} from 'src/tpbp-core/utils/formatter/formatter.const'
import type { DateTimeFormats } from 'vue-i18n'

const frDateTimeFormats = {
  [DATE_FORMATS.short]: {
    // 17/11/2022
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  },
  [DATE_FORMATS.long]: {
    // 17 novembre 2022
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  [DATE_FORMATS.year]: {
    // 2022
    year: 'numeric',
  },
  [DATE_FORMATS.advices]: {
    // 17 novembre 2022 à 03:24
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  },
  [DATE_FORMATS.month]: {
    // novembre
    month: 'long',
  },
  [DATE_FORMATS.monthYear]: {
    // novembre 2022
    year: 'numeric',
    month: 'long',
  },
  [DATE_FORMATS.day]: {
    // 17
    day: 'numeric',
  },
  [DATE_FORMATS.weekdayLong]: {
    // jeudi
    weekday: 'long',
  },
  [DATE_FORMATS.time]: {
    // 03:24
    hour: '2-digit',
    minute: '2-digit',
  },
  [DATE_FORMATS.timeShort]: {
    // 24:00
    minute: 'numeric',
    second: '2-digit',
  },
  [DATE_FORMATS.agenda]: {
    // jeudi 17 novembre 2022 à 03:24
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
    hour: '2-digit',
    minute: '2-digit',
  },
}

const frNumberFormats = {
  [NUMBER_FORMATS.currency]: {
    style: 'currency',
    currency: 'EUR',
  },
  [NUMBER_FORMATS.currencyWithSign]: {
    style: 'currency',
    currency: 'EUR',
    signDisplay: 'exceptZero',
  },
  [NUMBER_FORMATS.conciseCurrency]: {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  [NUMBER_FORMATS.conciseCurrencyWithSign]: {
    style: 'currency',
    currency: 'EUR',
    signDisplay: 'exceptZero',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  [NUMBER_FORMATS.percent]: {
    style: 'percent',
    maximumFractionDigits: 2,
  },
  [NUMBER_FORMATS.percent2digits]: {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  [NUMBER_FORMATS.concisePercent]: {
    style: 'percent',
    maximumFractionDigits: 0,
  },
  [NUMBER_FORMATS.parts]: {
    style: 'decimal',
    maximumFractionDigits: 4,
  },
  [NUMBER_FORMATS.notation]: {
    style: 'decimal',
    maximumFractionDigits: 2,
  },
  [NUMBER_FORMATS.integer]: {
    style: 'decimal',
    maximumFractionDigits: 0,
  },
  [NUMBER_FORMATS.oneDecimal]: {
    style: 'decimal',
    maximumFractionDigits: 1,
  },
  [NUMBER_FORMATS.twoDecimal]: {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  },
  // TODO check and remove this probably useless format
  year: {
    style: 'year',
    maximumFractionDigits: 0,
  },
}

export const FRENCH_LOCALE = 'fr-FR'
export const DEFAULT_LOCALE = FRENCH_LOCALE

export const dateTimeFormats = {
  [DEFAULT_LOCALE]: mapTypescriptRecord(frDateTimeFormats, castDateTimeFormat),
} as DateTimeFormats

export const numberFormats = {
  [DEFAULT_LOCALE]: mapTypescriptRecord(frNumberFormats, castNumberFormat),
} as DateTimeFormats
